var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24X24Chat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262C2E",
    d: "M11 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0M1 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0m20 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M11 22a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3.86-19.634a1 1 0 1 1 1.85.756 1 1 0 0 1-1.85-.756M1.819 7.836a1 1 0 1 1 1.85.756 1 1 0 0 1-1.85-.756m18.511 7.571a1 1 0 1 1 1.85.756 1 1 0 0 1-1.85-.756m-13.041 5.47a1 1 0 1 1 1.85.757 1 1 0 0 1-1.85-.757M18.364 4.222a1 1 0 1 1 1.414 1.413 1 1 0 0 1-1.414-1.413m-14.142 0a1 1 0 1 1 1.414 1.413 1 1 0 0 1-1.414-1.413m14.142 14.142a1 1 0 1 1 1.414 1.413 1 1 0 0 1-1.414-1.413m-14.142 0a1 1 0 1 1 1.414 1.413 1 1 0 0 1-1.414-1.413M20.835 7.21a1 1 0 1 1 .774 1.843 1 1 0 0 1-.774-1.843M7.745 1.856A1 1 0 1 1 8.52 3.7a1 1 0 0 1-.774-1.844M15.481 20.3a1 1 0 1 1 .774 1.843 1 1 0 0 1-.774-1.844M2.392 14.946a1 1 0 1 1 .773 1.844 1 1 0 0 1-.773-1.844M1.5 21.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7 9.3h10v1.5H7zm0 4h8v1.5H7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24X24Chat);
export default __webpack_public_path__ + "static/media/24x24_chat.8110199fb9bcd8c5cad116730086181d.svg";
export { ForwardRef as ReactComponent };